import styled from "@emotion/styled"
import { AppBar } from "@material-ui/core"
import Tab from "@material-ui/core/Tab"
import Tabs from "@material-ui/core/Tabs"
import { docketTheme } from "theme"

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: center;
`

export const StyledTab = styled(Tab)`
  color: ${docketTheme.colors.secondary.normal};
  min-width: 26rem;
  font-size: 1.8rem;
  font-weight: 700;
  margin: 0.5rem 0.5rem 0 0;
  height: 5rem;
  border: solid 0.2rem ${docketTheme.colors.grey[90]};
  border-bottom: none;
  background: ${({ selected }) => selected && docketTheme.colors.white};
  opacity: 1;
  line-height: 1.1;
`

export const StyledTabs = styled(Tabs)`
  .indicator {
    display: none;
  }
`

export const StyledAppBar = styled(AppBar)`
  box-sizing: content-box;
  left: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  height: 5.5rem;
  top: 7rem;
  background-color: ${docketTheme.colors.grey[95]};
`
